// import babelpolyfill from 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
//import './assets/theme/theme-green/index.css'
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/index.css'
import axios from '@/config/httpConfig'
import VueRouter from 'vue-router'
import store from '@/store/index'
import Vuex from 'vuex'
import "@/styles/index.css"
//import NProgress from 'nprogress'
//import 'nprogress/nprogress.css'
import routes from './routes'
// import Mock from './mock'
// Mock.bootstrap();
import 'font-awesome/css/font-awesome.min.css'
import 'lib-flexible'
import {processRoutingStructure} from '@/utils/index'
Vue.prototype.$http = axios
Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.use(Vuex)

Vue.config.productionTip = false
//NProgress.configure({ showSpinner: false });

const router = new VueRouter({
  routes
})
let data = JSON.parse(window.sessionStorage.getItem('menu'))
if (data){
  //这里是防止用户手动刷新页面，整个app要重新加载,动态新增的路由，会消失，所以我们重新add一次
 let datas = processRoutingStructure(data)
 console.log(datas);
  router.addRoutes(datas)
  sessionStorage.removeItem('isLoadNodes')
}
router.beforeEach((to, from, next) => {
  //NProgress.start();
  let data = JSON.parse(window.sessionStorage.getItem('menu'))
  if (data&&to.path == '/login') {
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('menu');
    sessionStorage.removeItem('isLoadNodes')
  }
  let user = JSON.parse(sessionStorage.getItem('user'));
  if (!user && to.path != '/login') {
    next({ path: '/login' })
  } else {
    next()
  }
})

//router.afterEach(transition => {
//NProgress.done();
//});

new Vue({
  //el: '#app',
  //template: '<App/>',
  router,
  store,
  //components: { App }
  render: h => h(App)
}).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js